import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "cm-align-center gap-x-10",
  style: {"align-self":"flex-end"}
}
const _hoisted_2 = { style: {"display":"inline-block"} }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { HIDE_FUNC } from '@/common/const/hide-function-config'
import type { ClientItem } from '@/views/dashboard/_type/client-item'
import { TerminalType, TerminalTypeLabel } from '@/views/dashboard/_enum/terminal-type'
import { TerminalLoginStatus } from '@/views/dashboard/_enum/terminal-login-status'
import { isClientSupportSsh, isClientSupportVnc, OS_REMOTE } from '@/views/dashboard/group/client/modals/remote-assist/remote-assist.service'
import { isVersionGte } from '@/utils/tool'
import RemoteAssist from '@/views/dashboard/group/client/modals/remote-assist/remote-assist.vue'
import ClientRebootModal from '@/views/dashboard/group/client/modals/client-reboot-modal.vue'
import ClientShutdownModal from '@/views/dashboard/group/client/modals/client-shutdown-modal.vue'
import { ClientService } from '@/views/dashboard/group/client/client.service'
import { isolation_status } from '@/views/dashboard/response-manage/response-handle/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-head-remote-actions',
  props: {
    detailInfo: {}
  },
  emits: ["handleNet"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const injector = useReflectiveInjector([ClientService])
const clientService = injector.get(ClientService)

const remoteAssistDialog = ref(false)
const clientModal = ref({
  MODAL_CLIENT_SHUTDOWN: false,
  MODAL_CLIENT_REBOOT: false,
})

function isIsolated (status?: number) {
  return [isolation_status.separated, isolation_status.recovering, isolation_status.recoverFail].includes(
    status as isolation_status,
  )
}

const shutdownRebootDisabled = computed(
  () => props.detailInfo?.login_status !== TerminalLoginStatus.online,
)

const remoteDisableTip = computed(() => {
  const item = props.detailInfo
  if (!item?.system_type) return null
  const config = OS_REMOTE[item.system_type]
  if (!config?.has_old && !config?.has_vnc && !config?.has_ssh) {
    return t('responseHandle.remoteOsNotSupported')
  }
  if (
    !config.has_old &&
    !isClientSupportVnc(item.version, item.system_type) &&
    !isClientSupportSsh(item.version, item.system_type)
  ) {
    const { vnc_cversion, ssh_cversion } = config
    const minVersion = isVersionGte(vnc_cversion, ssh_cversion) ? ssh_cversion : vnc_cversion
    return t('responseHandle.remoteClientVersionLow', {
      os: TerminalTypeLabel[item.system_type],
      version: minVersion,
    })
  }
  if (item.login_status !== TerminalLoginStatus.online) {
    return t('responseHandle.remoteTerminalOffline')
  }
  return null
})

function openModal (type: 'MODAL_CLIENT_SHUTDOWN' | 'MODAL_CLIENT_REBOOT') {
  clientModal.value[type] = true
}

function closeClientModal (type: string) {
  if (type in clientModal.value) {
    clientModal.value[type as keyof typeof clientModal.value] = false
  }
}

function shutDownTer () {
  const item = props.detailInfo
  if (!item?.device_id) return
  clientService
    .shutDownTerminal({
      execute_type: 0,
      device_list: [item.device_id],
      group_id: item.group_id ?? -1,
    })
    .then(() => {
      ElMessage.success(t('responseHandle.shutdownCmdSuccess', { count: 1 }))
    })
    .catch(() => {
      ElMessage.error(t('responseHandle.shutdownCmdFail', { count: 1 }))
    })
}

function restartTer () {
  const item = props.detailInfo
  if (!item?.device_id) return
  clientService
    .restartTerminal({
      execute_type: 0,
      device_list: [item.device_id],
      group_id: item.group_id ?? -1,
    })
    .then(() => {
      ElMessage.success(t('responseHandle.rebootCmdSuccess', { count: 1 }))
    })
    .catch(() => {
      ElMessage.error(t('responseHandle.rebootCmdFail', { count: 1 }))
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(HIDE_FUNC).remoteAssist)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            "append-to-body": "",
            disabled: !remoteDisableTip.value,
            effect: "light",
            content: remoteDisableTip.value || '',
            placement: "bottom"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  disabled: !!remoteDisableTip.value,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (remoteAssistDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.remoteOp')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["disabled", "content"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "text",
        disabled: shutdownRebootDisabled.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal('MODAL_CLIENT_SHUTDOWN')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.shutdown')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "text",
        disabled: shutdownRebootDisabled.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (openModal('MODAL_CLIENT_REBOOT')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.reboot')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    (remoteAssistDialog.value && _ctx.detailInfo?.device_id)
      ? (_openBlock(), _createBlock(RemoteAssist, {
          key: 0,
          "terminal-info": _ctx.detailInfo,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (remoteAssistDialog.value = false))
        }, null, 8, ["terminal-info"]))
      : _createCommentVNode("", true),
    _createVNode(ClientRebootModal, {
      show: clientModal.value.MODAL_CLIENT_REBOOT,
      count: 1,
      onRestartTer: restartTer,
      onCloseClientModal: closeClientModal
    }, null, 8, ["show"]),
    _createVNode(ClientShutdownModal, {
      show: clientModal.value.MODAL_CLIENT_SHUTDOWN,
      count: 1,
      onShutDownTer: shutDownTer,
      onCloseClientModal: closeClientModal
    }, null, 8, ["show"])
  ], 64))
}
}

})